class BuyXGetXVariant {
    constructor() {
        this.init();
    }

    init() {
        this.setupEventListeners();
        this.checkProductTag();
    }

    setupEventListeners() {
        // Listen for quantity changes
        document.addEventListener('change', (event) => {
            if (event.target.matches('.quantity__input')) {
                this.handleQuantityChange(event);
            }
        });

        // Listen for form submission
        const form = document.querySelector('form[action="/cart/add"]');
        if (form) {
            form.addEventListener('submit', (event) => {
                event.preventDefault();
                this.handleFormSubmit(event);
            });
        }
    }

    checkProductTag() {
        const productTags = document.querySelector('[data-product-tags]')?.dataset.productTags;
        if (productTags && productTags.includes('buyxgetx')) {
            this.initializeVariants();
        }
    }

    initializeVariants() {
        const quantity = parseInt(document.querySelector('.quantity__input')?.value || 1);
        this.updateVariants(quantity);
    }

    handleQuantityChange(event) {
        const quantity = parseInt(event.target.value);
        this.updateVariants(quantity);
    }

    updateVariants(quantity) {
        const variantContainer = document.querySelector('.productView-variants');
        if (!variantContainer) return;

        // Remove existing carpet variants
        const existingVariants = document.querySelectorAll('.carpet-variant-container');
        existingVariants.forEach(variant => variant.remove());

        // Get the original variant picker
        const originalVariantPicker = variantContainer.querySelector('.product-option');
        if (!originalVariantPicker) return;

        // Create container for all carpet variants
        const carpetVariantsContainer = document.createElement('div');
        carpetVariantsContainer.className = 'carpet-variants-wrapper';
        originalVariantPicker.after(carpetVariantsContainer);

        // Create variant pickers for each quantity
        for (let i = 1; i <= quantity; i++) {
            const carpetVariant = this.createCarpetVariant(originalVariantPicker, i);
            carpetVariantsContainer.appendChild(carpetVariant);
        }

        // Hide original variant picker
        originalVariantPicker.style.display = 'none';
    }

    createCarpetVariant(originalPicker, index) {
        // Create container for this carpet variant
        const container = document.createElement('div');
        container.className = 'carpet-variant-container';
        container.dataset.variantIndex = index;

        // Add title
        const title = document.createElement('div');
        title.className = 'carpet-variant-title';
        title.textContent = `Carpet ${index}`;
        container.appendChild(title);

        // Clone the variant picker
        const variantPicker = originalPicker.cloneNode(true);
        variantPicker.classList.add('carpet-variant-clone');
        
        // Update IDs and names
        this.updateClonedElements(variantPicker, index);
        
        // Add the variant picker to container
        container.appendChild(variantPicker);

        // Add name field
        this.addNameField(container, index);

        // Initialize the variant selectors
        this.initializeVariantSelectors(variantPicker);

        return container;
    }

    updateClonedElements(variantPicker, index) {
        // Update all IDs
        variantPicker.querySelectorAll('[id]').forEach(el => {
            el.id = `${el.id}-${index}`;
        });

        // Update all names and for attributes
        variantPicker.querySelectorAll('[name]').forEach(el => {
            const originalName = el.getAttribute('name');
            el.setAttribute('name', `${originalName}-${index}`);
        });

        variantPicker.querySelectorAll('[for]').forEach(el => {
            const originalFor = el.getAttribute('for');
            el.setAttribute('for', `${originalFor}-${index}`);
        });

        // Update data attributes
        const radioContainer = variantPicker.querySelector('variant-radios');
        if (radioContainer) {
            radioContainer.dataset.section = `${radioContainer.dataset.section}-${index}`;
        }
    }

    initializeVariantSelectors(variantPicker) {
        const radioButtons = variantPicker.querySelectorAll('input[type="radio"]');
        radioButtons.forEach(radio => {
            radio.addEventListener('change', (event) => {
                const optionIndex = event.target.closest('.product-form__input').dataset.optionIndex;
                const value = event.target.value;
                
                // Update the option label
                const label = event.target.closest('fieldset').querySelector('[data-header-option]');
                if (label) {
                    label.textContent = value;
                }

                // Update hidden input with all selected variants
                this.updateSelectedVariants();
            });
        });
    }

    addNameField(container, index) {
        const nameField = document.createElement('div');
        nameField.className = 'carpet-name-field';
        nameField.innerHTML = `
            <label class="form__label">Name for Carpet ${index}:</label>
            <input type="text" 
                   class="field__input"
                   name="properties[Carpet ${index} Name]" 
                   required>
        `;
        container.appendChild(nameField);
    }

    async handleFormSubmit(event) {
        event.preventDefault();
        const form = event.target;
        
        try {
            const containers = document.querySelectorAll('.carpet-variant-container');
            const quantity = containers.length;
            
            if (quantity === 0) return;

            // Show loading state
            const submitButton = form.querySelector('[type="submit"]');
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = 'Adding to Cart...';
            }

            // Get the main product variant ID
            const mainVariantId = form.querySelector('[name="id"]')?.value;
            if (!mainVariantId) throw new Error('Product variant not found');

            // Collect all carpet data
            const carpetData = [];
            for (const container of containers) {
                const variantData = this.collectVariantData(container);
                if (!variantData.name) {
                    alert('Please enter names for all carpets');
                    return;
                }
                carpetData.push(variantData);
            }

            // Create the main cart item with all carpet data
            const formData = new FormData();
            formData.append('id', mainVariantId);
            formData.append('quantity', quantity);

            // Add each carpet's data as properties
            carpetData.forEach((carpet, index) => {
                const prefix = `Carpet ${index + 1}`;
                formData.append(`properties[${prefix} Name]`, carpet.name);
                
                // Add all selected options
                Object.entries(carpet.options).forEach(([key, value]) => {
                    formData.append(`properties[${prefix} ${key}]`, value);
                });
            });

            // Add to cart
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });

            if (!response.ok) throw new Error('Failed to add to cart');

            // Redirect to cart page
            window.location.href = '/cart';

        } catch (error) {
            console.error('Error adding items to cart:', error);
            alert('There was an error adding items to cart. Please try again.');
        } finally {
            // Reset submit button
            const submitButton = form.querySelector('[type="submit"]');
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = 'Add to Cart';
            }
        }
    }

    collectVariantData(container) {
        const selectedOptions = {};
        const optionSelects = container.querySelectorAll('.product-form__input');
        
        // Collect all selected options
        optionSelects.forEach(select => {
            const label = select.querySelector('.form__label');
            if (!label) return;

            const optionName = label.textContent.split(':')[0].trim();
            const selectedInput = select.querySelector('input[type="radio"]:checked');
            
            if (selectedInput) {
                selectedOptions[optionName] = selectedInput.value;
            }
        });

        // Get the name input value
        const nameInput = container.querySelector('.carpet-name-field input');
        const name = nameInput?.value?.trim() || '';

        return {
            options: selectedOptions,
            name
        };
    }

    findVariantId(selectedOptions) {
        // Get the variants JSON from the page
        const variantsJson = document.querySelector('[data-variants]')?.textContent;
        if (!variantsJson) return null;

        try {
            const variants = JSON.parse(variantsJson);
            
            // Find the variant that matches all selected options
            const variant = variants.find(variant => {
                return Object.entries(selectedOptions).every(([option, value]) => {
                    return variant[option.toLowerCase()] === value;
                });
            });

            return variant?.id;
        } catch (error) {
            console.error('Error parsing variants:', error);
            return null;
        }
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new BuyXGetXVariant();
});
